const DPermanentContent = `

Permanent physical disabilities for the purposes of deduction under section 80U.

11D. [Omitted by the IT (Twentieth Amdt.) Rules, 2003, w.r.e.f. 1-4-2003.]

`;

export default DPermanentContent;